<template>
    <el-drawer :modal="false" 
        :title="'Case: '+ _gHlp.getValue(product,'prod_case_no','N/A') "
        :visible.sync="is_visible"
        class="case-details-drawer"
        size="45%"
        @close="hide"
    >
			<div style="min-height:300px" v-loading="is_loading" element-loading-text="Optimize Case Detail...">
        <DisableCaseCard :product="product"/>
        <b-container  v-if="!_gHlp.isEmpty(product)">
            <el-collapse v-model="activeNames">
                <el-collapse-item name="1" class="my-3">
                    <div slot="title" class="collapse-header w-100">
                        <div class="d-flex align-items-center justify-content-between">
                            <h3 class="mb-0">Other Cases</h3>
                        </div>
                    </div>
                    <OtherLoanCaseDetails :product="product"/>
                </el-collapse-item>
            </el-collapse>
						<b-row v-if="checkCanGenerateCommision(product)">
							<b-col md="12" class="mx-auto text-center mt-4 pt-2">
								<b-button variant="primary" type="button" @click="generateProductCommission(product)">Generate Commission</b-button>
							</b-col>
						</b-row>
						<b-row v-if="!_gHlp.isEmpty(product.prod_commission_at)">
							<b-col md="12" class="mx-auto text-center mt-4 pt-2">
								<p class="text-danger">PRODUCT SALES COMMISSION HAS BEEN GENERATED AT {{ _gHlp.formatMomentDate(product.prod_commission_at) }}</p>
							</b-col>
						</b-row>
        </b-container>
			</div>
    </el-drawer>
</template>
<script>
import { Drawer, Collapse, CollapseItem, Button } from 'element-ui'
import OtherLoanCaseDetails from './OtherLoanCaseDetails.vue'
import DisableCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/DisableCaseCard'
import { mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'    

export default {
    components: {
        DisableCaseCard,
        OtherLoanCaseDetails,
        [Drawer.name]: Drawer,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
    },
    data() {
        return {
						product:null,
            is_visible: false,
            is_loading: false,
            // banks:[],
            activeNames:['1','2'],
            // lawyer_details: null,
        }
    },
    methods: {
				...mapActions(useProductStore, ['getCustomerProducts','getProduct', 'checkCanGenerateCommision', 'generateProductCommission']),
        async show(product_id) {
						this.is_loading = true
						this.is_visible = true
						this.product = await this.getProduct(product_id);
						this.is_loading = false
        },
				hide(){
					this.product = null
        },
    }
}
</script>